import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import { formatDateTimeDDMMMYYYY } from '../../utils/dateFormat';
import { exportReportToExcelLikeAuditDtl } from '../../utils/exportToExcel';
import Alert from '../Common/Alert';
import './ReportsHome.css';
import './AuditReport.css';

/** Parse a value as UTC for display (same pattern as DCFReport). */
function parseUtcForDisplay(value) {
  if (value == null) return null;
  const s = typeof value === 'string' ? value.trim() : (value instanceof Date ? value.toISOString() : String(value));
  if (!s) return null;
  let asUtc = s;
  if (!asUtc.endsWith('Z') && !asUtc.includes('+')) {
    asUtc = asUtc.replace(' ', 'T') + (asUtc.includes('T') ? '' : 'T00:00:00') + 'Z';
  }
  const d = new Date(asUtc);
  return Number.isNaN(d.getTime()) ? null : d;
}

function formatUtcCell(value) {
  if (value == null || value === '') return '';
  const d = parseUtcForDisplay(value);
  if (d == null) return '';
  const s = formatDateTimeDDMMMYYYY(d, true);
  return s === '—' ? '' : s;
}

const EXPORT_COLUMNS = [
  { key: 'application', label: 'Application' },
  { key: 'userName', label: 'UserName' },
  { key: 'logInUtc', label: 'Log In (Date & Time UTC)' },
  { key: 'logOutUtc', label: 'Log out (Date & Time UTC)' },
  { key: 'ipAddress', label: 'IP Address' },
];

const COL_WIDTHS = [28, 24, 26, 26, 18];

function mapRow(d) {
  const loginRaw = d.loginUtc ?? d.LoginUtc;
  const logoutRaw = d.logoutUtc ?? d.LogoutUtc;
  return {
    application: (d.application ?? d.Application ?? '').toString(),
    userName: (d.userName ?? d.UserName ?? '').toString(),
    logInUtc: formatUtcCell(loginRaw),
    logOutUtc: formatUtcCell(logoutRaw),
    ipAddress: (d.ipAddress ?? d.IpAddress ?? '').toString(),
  };
}

const LoginLogoutReport = () => {
  const navigate = useNavigate();
  const [exportLoading, setExportLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleExportExcel = async () => {
    setError(null);
    setExportLoading(true);
    try {
      const res = await api.get('/Report/login-logout', { params: { limit: 10000 } });
      const list = Array.isArray(res.data) ? res.data : [];
      const exportRows = list.map(mapRow);
      const fileName = `Login_Logout_Report_${new Date().toISOString().slice(0, 10)}.xlsx`;
      exportReportToExcelLikeAuditDtl(exportRows, EXPORT_COLUMNS, fileName, {
        sheetName: 'Login Logout Report',
        colWidths: COL_WIDTHS,
      });
    } catch (err) {
      setError(err?.response?.data?.error || err?.message || 'Export failed.');
    } finally {
      setExportLoading(false);
    }
  };

  return (
    <div className="audit-report">
      <div className="audit-report-header" style={{ marginBottom: '16px' }}>
        <h2>Login/Logout Report</h2>
       
      </div>

      {error && <Alert type="error" message={error} />}

      <div className="audit-report-actions">
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleExportExcel}
          disabled={exportLoading}
          title={exportLoading ? 'Exporting…' : 'Export'}
        >
          {exportLoading ? 'Exporting…' : 'Export'}
        </button>
        <button type="button" className="btn btn-secondary" onClick={() => navigate('/reports')}>
          Close
        </button>
      </div>
    </div>
  );
};

export default LoginLogoutReport;
